/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splash from "./assets/lottie/splash"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splash,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Prince Amit",
  title: "Hi all, I’m Prince",
  subTitle: emoji(
    "Data Scientist & GenAI Engineer at Keysight Technologies. 5+ years building AI systems that drive measurable impact — LLM-powered agents, RAG pipelines, OCR at scale, and end-to-end MLOps. I turn complex data into production-grade intelligence."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1b1XOY-9qU1DBtVV6Ks47sdJ4d3EmKD4I/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/princeamitlali",
  linkedin: "https://www.linkedin.com/in/princeamitlali/",
  gmail: "mailto:princeamitlali.ml@gmail.com",
  // github: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@princeamitlali",
  stackoverflow: "https://scholar.google.com/citations?hl=en&user=LpH1OiUAAAAJ",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "Building intelligent systems that bridge cutting-edge AI research and production-grade engineering — one model at a time.",
  skills: [
    emoji("⚡ Designing and deploying LLM-powered agents, RAG pipelines, and GenAI applications"),
    emoji("⚡ Building scalable OCR, NLP, and Computer Vision systems for enterprise use cases"),
    emoji("⚡ Engineering end-to-end ML workflows — from data ingestion to model serving"),
    emoji("⚡ Implementing MLOps: model versioning, CI/CD, monitoring, and drift detection"),
    emoji("⚡ Cloud-native AI solutions on AWS, GCP, and Databricks with PySpark & BigQuery"),
    emoji("⚡ Integrating AI models into production APIs using FastAPI and Docker")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "TensorFlow",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "PyTorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "scikit-learn",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "LangChain",
      fontAwesomeClassname: "fas fa-link"
    },
    {
      skillName: "HuggingFace",
      fontAwesomeClassname: "fas fa-smile"
    },
    {
      skillName: "NLP",
      fontAwesomeClassname: "fas fa-comment-dots"
    },
    {
      skillName: "Computer Vision",
      fontAwesomeClassname: "fas fa-eye"
    },
    {
      skillName: "Big Data",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section
  schools: [
    {
      schoolName: "Indian Institute of Technology Patna",
      logo: require("./assets/images/IITP.png"),
      subHeader: "M.Tech. in Artificial Intelligence and Data Science Engineering",
      duration: "2023 - 2025",
      desc: "Specialized in AI and Data Science with a strong academic record (95% equivalent grade) while working on applied research and industry projects.",
      descBullets: [
        "Core coursework: Machine Learning, Deep Learning, NLP, Computer Vision, and Cloud Computing.",
        "Published two research papers in Springer Nature on AI-driven assistive systems and crowd management.",
        "Collaborated on AI-driven industry projects bridging academic research with real-world deployment."
      ],
      website_link: "https://www.iitp.ac.in/"
    },
    {
      schoolName: "Bakhtiyarpur College of Engineering",
      logo: require("./assets/images/bce.png"),
      subHeader: "B.Tech in Computer Science and Engineering",
      duration: "2016 - 2020",
      desc: "Explored AI, Explainable AI, Graph Machine Learning, and Computer Vision.",
      descBullets: [
        "Worked on cutting-edge AI projects with national and international companies.",
        "Research intern at IIT Patna, contributing to NLP projects."
      ],
      website_link: "https://bcebakhtiyarpur.ac.in/"
    }
  ]
};


// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Show Proficiency Section
  experience: [

  // AI / ML
  { Stack: "Machine Learning", color: "#1E3A8A" },   // blue
  { Stack: "Deep Learning", color: "#1E3A8A" },
  { Stack: "Generative AI", color: "#1E3A8A" },
  { Stack: "Large Language Models (LLMs)", color: "#1E3A8A" },
  { Stack: "Natural Language Processing (NLP)", color: "#1E3A8A" },
  { Stack: "Computer Vision", color: "#1E3A8A" },

  // Data Science
  { Stack: "Data Science", color: "#059669" },   // teal/green


  // MLOps & Deployment
  { Stack: "MLOps", color: "#9333EA" },  // purple
  { Stack: "Model Deployment", color: "#9333EA" },


  // Cloud

  { Stack: "Amazon Web Services (AWS)", color: "#2563EB" },


  // Big Data & Warehousing
  { Stack: "PySpark", color: "#DC2626" },   // red
  { Stack: "Databricks", color: "#DC2626" },
  { Stack: "BigQuery", color: "#DC2626" },


  // Data Engineering & Orchestration
  { Stack: "ETL Pipelines", color: "#F59E0B" }, // orange
  { Stack: "DAGs", color: "#F59E0B" },
  { Stack: "Apache Airflow", color: "#F59E0B" },

  // Programming
  { Stack: "Python", color: "#4B5563" }, // gray
  { Stack: "SQL", color: "#4B5563" },

  // ML Frameworks
  { Stack: "TensorFlow", color: "#EA580C" }, // deep orange
  { Stack: "PyTorch", color: "#EA580C" },
  { Stack: "scikit-learn", color: "#EA580C" },
  { Stack: "Keras", color: "#EA580C" },

  // Visualization
  { Stack: "Looker Studio", color: "#10B981" }, // green
  { Stack: "Matplotlib", color: "#10B981" },
  { Stack: "Seaborn", color: "#10B981" }


  ],
  displayCodersrank: false // Hide CodersRank badges
};




// Work experience section

const workExperiences = {
  display: true, // Set to true to show workExperiences Section
  experience: [
    {
      role: "Data Scientist",
      company: "Keysight Technologies",
      companylogo: require("./assets/images/keysight.png"),
      date: "Feb 2026 – Present",
      desc: "Building AI and ML solutions within the measurement intelligence and R&D domain at a global electronics test & measurement leader.",
      descBullets: [
        "Leading process modernization by architecting a centralized ML library — an internal sklearn-equivalent — to standardize and accelerate all ML workflows across teams.",
        "Designing reusable, modular components for data preprocessing, model training, evaluation, and deployment to eliminate redundant work across projects.",
        "Driving adoption of unified ML standards and best practices to improve consistency, reproducibility, and scalability of models across the organization."
      ]
    },
    {
      role: "Data Scientist",
      company: "Paktolus Solutions",
      companylogo: require("./assets/images/paktolus.jpg"),
      date: "Mar 2024 – Dec 2025",
      desc: "Designed and shipped end-to-end GenAI and data science solutions for enterprise clients — from research to production.",
      descBullets: [
        "Built LLM-powered SQL agents enabling natural language querying over large enterprise databases.",
        "Developed an OCR pipeline processing millions of government ID documents with role-based access control and image encryption.",
        "Architected scalable ML workflows on AWS using FastAPI and Docker for client-facing production deployment."
      ]
    },
    {
      role: "Data Scientist",
      company: "LTIMindtree",
      companylogo: require("./assets/images/lti.png"),
      date: "Mar 2021 – Mar 2024",
      desc: "Delivered data science and ML solutions for Fortune 500 retail and manufacturing clients across 3 years.",
      descBullets: [
        "Built an ML-driven product assortment model achieving 14% improvement in line coverage.",
        "Reduced operational costs by 15% and increased sales efficiency by 10% through automated reporting pipelines.",
        "Processed terabytes of transactional data using PySpark, Databricks, and BigQuery."
      ]
    },
    {
      role: "Machine Learning Intern",
      company: "VEStellaLab Inc.",
      companylogo: require("./assets/images/vst.png"),
      date: "May 2022 – Aug 2022",
      desc: "Improved ML training data quality and anti-cheating mechanisms using computer vision and sensor integration.",
      descBullets: [
        "Integrated OpenCV and ultrasonic sensors to enhance data collection pipelines.",
        "Built anomaly detection models to identify and filter low-quality training samples."
      ]
    },
    {
      role: "Research Intern",
      company: "Indian Institute of Technology, Patna",
      companylogo: require("./assets/images/IITP.png"),
      date: "May 2019 – Sept 2019",
      desc: "Conducted NLP research on automatic text summarization contributing to peer-reviewed academic publications.",
      descBullets: [
        "Fine-tuned BERT for extractive summarization across multi-domain corpora.",
        "Co-authored research on NLP systems published in Springer Nature."
      ]
    }
  ]
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements and Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters, and Some Cool Stuff that I have done!",

  achievementsCards: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      image: require("./assets/images/stanford_logo.png"),
      imageAlt: "Stanford University Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/J5E349QYPP8C"
        }
      ]
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      image: require("./assets/images/ibm_logo.png"),
      imageAlt: "IBM Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/professional-cert/U5SEGMEV5HR3"
        }
      ]
    },
    {
      title: "Applied Machine Learning in Python",
      subtitle: "- Kevyn Collins-Thompson",
      image: require("./assets/images/um.png"),
      imageAlt: "Microsoft Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/verify/GJVSYN8FYQEB"
        }
      ]
    },
    {
      title: "Big Social Data Analysis",
      subtitle: "- Erik Cambria",
      image: require("./assets/images/gian.png"),
      imageAlt: "GIAN Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1YaagQb8YH2A23s9wG6Prdge1t6rCTUVi/view?usp=sharing"
        }
      ]
    },
    {
      title: "Introduction to Machine Learning",
      subtitle: "- Balaraman Ravindran",
      image: require("./assets/images/nptel_logo.png"),
      imageAlt: "NPTEL Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://archive.nptel.ac.in/noc/Ecertificate/?q=noc18-cs26/NPTEL18CS26S37200991810090917.jpg"
        }
      ]
    },
    {
      title: "Unsupervised Mining: from Batch to Stream Mining Algorithms",
      subtitle: "- Stefan Kramar",
      image: require("./assets/images/gian.png"),
      imageAlt: "IBM Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/drive/folders/177NJcfvPuqI58ow5dkIOQtoCzryVL5Ei"
        }
      ]
    },
    {
      title: "AI From the Data Center to the Edge – An Optimized Path Using Intel® Architecture",
      subtitle: "- Intel Labs",
      image: require("./assets/images/intel.png"),
      imageAlt: "Intel Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/vvr5zd6l?key=f02f7d288a98f5e583117c26004fc2d73e49dec91d9869ac069d9696b79c830a"
        }
      ]
    },
    {
      title: "Foundation of Generative AI",
      subtitle: "- Udacity",
      image: require("./assets/images/udacity.png"),
      imageAlt: "Udacity Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udacity.com/certificate/e/a772de88-b7bc-11ef-bed1-ef4266fc1154"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Blogs Section

const blogSection = {
  title: "Publications",
  subtitle:
    "With a passion for research and development, I love to share my published works and insights with the world.",
  displayMediumBlogs: "false", // Set false to use hardcoded publications
  blogs: [
    {
      url: "https://link.springer.com/chapter/10.1007/978-981-97-1757-6_40",
      title:
        "Personalized Navigation System: A Computer-Based System for Visually Impaired to Interact with Its Surroundings",
      description: "Paper published in Springer Nature."
    },
    {
      url: "https://link.springer.com/chapter/10.1007/978-981-97-1757-6_41",
      title: "Hajj Crowd Control for Better Management of Pilgrims",
      description: "Paper published in Springer Nature."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "NUMBER SYSTEM",
      subtitle: "Medium.com",
      slides_url: "https://medium.com/@princeamitlali/number-system-5a1641dddcfa"
    },
    {
      title: "Tech Industry in 2020",
      subtitle: "Medium.com",
      slides_url: "https://medium.com/@princeamitlali/tech-industry-in-2020-3e20c9db35ba"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Have an interesting AI problem, a collaboration idea, or just want to connect? My inbox is always open.",
  number: "+91-6202421727",
  email_address: "princeamitlali.ml@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
